import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { removeAccessToken, removeRefreshToken } from "src/api";
import { userLogout } from "src/api/user/auth";
import { useRedirect } from "src/navigation/useRedirect";
import { setUserProfile } from "src/store/profile/profileSlice";
import { RESPONSSTAUTS } from "src/types/api";
import { PAGES } from "src/types/navigation";
import { QUERYKEYS } from "src/types/queryKeys";
import { t } from "src/utils/i18nText";

export const useUserLogout = () => {
  const queryClient = useQueryClient();

  const [errorMessage, setErrorMessage] = useState("");
  const { redirect } = useRedirect();
  const dispatch = useDispatch();
  const { mutateAsync, isPending, isError, data, isSuccess } = useMutation({
    mutationKey: [QUERYKEYS.LOGOUT],
    mutationFn: () => userLogout(),
    onSuccess: (data) => {
      if (data?.status === RESPONSSTAUTS.SUCCESS_NO_CONTENT) {
        removeAccessToken();
        removeRefreshToken();
        redirect({ scheme: PAGES.ROOT });
        dispatch(setUserProfile(null));
        queryClient.invalidateQueries({
          queryKey: [QUERYKEYS.EVENTS],
          refetchType: "active",
        });
      } else {
        const errorMsg = t("queries.common.error");
        setErrorMessage(errorMsg);
      }
    },
    onError: () => {
      const errorMsg = t("queries.common.error");
      setErrorMessage(errorMsg);
    },
  });

  return {
    isSuccess,
    data,
    isError,
    isPending,
    logoutMutate: mutateAsync,
    errorMessage,
  };
};
